import { createSvgIcon } from "@mui/material/utils";

const InfoFillIcon = createSvgIcon(
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 0.833008C11.958 0.833008 15.167 4.04196 15.167 8C15.167 11.958 11.958 15.167 8 15.167C4.04196 15.167 0.833008 11.958 0.833008 8C0.833008 4.04196 4.04196 0.833008 8 0.833008ZM8 9.91699C7.40195 9.91717 6.91717 10.4019 6.91699 11C6.91717 11.5981 7.40195 12.0838 8 12.084C8.59805 12.0838 9.08381 11.5981 9.08398 11C9.08382 10.4394 8.6572 9.9786 8.11133 9.92285L8 9.91699ZM7.66699 11.2471C7.61568 11.1779 7.58406 11.0927 7.58398 11C7.58406 10.9071 7.61552 10.8222 7.66699 10.7529V11.2471ZM8.33398 10.7529C8.38525 10.8221 8.41692 10.9073 8.41699 11C8.41692 11.0927 8.38522 11.1779 8.33398 11.2471V10.7529ZM8 3.91699C7.58594 3.91717 7.25 4.25289 7.25 4.66699V8.66699C7.25018 9.08095 7.58604 9.41682 8 9.41699C8.41396 9.41682 8.74982 9.08095 8.75 8.66699V4.66699C8.75 4.25289 8.41406 3.91717 8 3.91699Z"
      fill="currentColor"
    />
  </svg>,
  "InfoFill"
);

export default InfoFillIcon;
